// Module
var code = "<react-component name=\"PosSales\"></react-component>\n";
// Exports
module.exports = code;